import { Button, Card, Text, Flex, ActionIcon, useComputedColorScheme } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import type { Props as JoyrideProps, TooltipRenderProps } from 'react-joyride';
import Joyride from 'react-joyride';

export const JOYRIDE_Z_INDEX = 1000;

function CustomTooltip({
  backProps,
  closeProps,
  continuous,
  index,
  primaryProps,
  skipProps,
  step,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) {
  return (
    <Card
      {...tooltipProps}
      className="relative max-w-xs p-4 shadow-lg"
    >
      {!step.hideCloseButton ?
        <ActionIcon
          {...closeProps}
          className="absolute right-1 top-1"
          variant="transparent"
          color="gray"
        >
          <IconX size={15} />
        </ActionIcon>
      : null}

      <div className="mt-3" />

      {!!step.title && <Text className="mb-2 text-center text-xl font-semibold">{step.title}</Text>}

      <Text className="text-center text-sm">{step.content}</Text>

      <Flex
        justify="space-between"
        align="center"
        className="mt-4 w-full"
      >
        <Button
          variant="subtle"
          size="sm"
          color="blue"
          {...skipProps}
          title="Exit"
          className={index > 0 ? 'visible' : 'invisible'}
        >
          Exit
        </Button>

        <Flex gap="xs">
          {index > 0 && !step.hideBackButton ?
            <Button
              variant="subtle"
              size="sm"
              color="gray"
              {...backProps}
            >
              {backProps.title}
            </Button>
          : null}
          {continuous ?
            <Button
              size="sm"
              color="blue"
              {...primaryProps}
              title={isLastStep ? 'Finish' : 'Next'}
            >
              {isLastStep ? 'Finish' : 'Next'}
            </Button>
          : null}
        </Flex>
      </Flex>
    </Card>
  );
}

const MantineJoyride = (props: JoyrideProps) => {
  const colorScheme = useComputedColorScheme();

  return (
    <Joyride
      {...props}
      // This is needed since without it, any mantine ScrollArea component will break upon running the tour
      disableScrollParentFix
      tooltipComponent={CustomTooltip}
      floaterProps={{
        styles: {
          arrow: {
            color: colorScheme === 'dark' ? 'var(--mantine-color-dark-6)' : 'white',
          },
        },
      }}
      styles={{
        options: {
          zIndex: JOYRIDE_Z_INDEX,
        },
        beacon: { visibility: 'hidden' },
      }}
    />
  );
};

export default MantineJoyride;
